import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

export default {
  async getAllExemptions() {
    const response = await axiosPrivate.get('/exemptions');

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },
};
